import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';
import {AppContainerModule, AppContainerOptions, MydocmaServiceWorkerModule} from '@mydocma/app-container';
import {AppRoutingModule, routes} from './app-routing.module';
import {AppComponent} from './app.component';
import {MainComponent} from './main/main.component';
import {HttpClient, HttpClientModule} from '@angular/common/http';
import {AuthModule} from '@mydocma/auth';
import {ProjectModule} from '@mydocma/project';
import {CustomerModule} from '@mydocma/customer';
import {MediaQueryService, MediatorService, PersonalizationService} from '@mydocma/core';
import {TranslateLoader, TranslateModule, TranslatePipe, TranslateService} from '@ngx-translate/core';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {PopoverModule} from "@mydocma/component-library";
import {registerLocaleData} from '@angular/common';
import localeDE from '@angular/common/locales/de';
import localeEN from '@angular/common/locales/en';
import { ModuleTranslateLoader } from "@larscom/ngx-translate-module-loader";
import { RouterModule } from '@angular/router';
import { MAT_LEGACY_DIALOG_DEFAULT_OPTIONS } from '@angular/material/legacy-dialog';
import { MydocmaDeviceType } from '@mydocma/core/src/lib/device';
import { MydocmaTaskModule } from '@mydocma/task';
import { MydocmaLoggerModule } from '@mydocma/common/src/lib/logger';
import { MyDocmaSystemPagesModule } from '@mydocma/component-library/src/lib/system-pages';

export function createTranslateLoader(http: HttpClient) {

  const baseTranslateUrl = './assets/i18n';

  return new ModuleTranslateLoader(http, {
      modules: [
        {moduleName: 'app-container', baseTranslateUrl},
        {moduleName: 'project', baseTranslateUrl},
        {moduleName: 'customer', baseTranslateUrl}, 
        {moduleName: 'comp-lib', baseTranslateUrl},
        {moduleName: 'form', baseTranslateUrl},
        {moduleName: 'jf', baseTranslateUrl},
        {moduleName: 'pix-common', baseTranslateUrl}
      ]
    }
  );
}


@NgModule({
  declarations: [
    AppComponent,
    MainComponent
  ],
  imports: [
    RouterModule,
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    HttpClientModule,
    MydocmaLoggerModule.forRoot(),
    AppContainerModule,
    PopoverModule,
    AuthModule.forRoot(),
    CustomerModule.forRoot(),
    ProjectModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (createTranslateLoader),
        deps: [HttpClient],
      },
    }),
    MydocmaServiceWorkerModule,
    MydocmaTaskModule,
    MyDocmaSystemPagesModule
  ],
  providers: [
    {
      provide: AppContainerOptions, 
      useFactory: () => {
        const options = new AppContainerOptions() as AppContainerOptions;
        options.blockedDeviceTypes = [MydocmaDeviceType.Mobile];
        return options;
      }
    },
    MediatorService,
    MediaQueryService,
    { provide: MAT_LEGACY_DIALOG_DEFAULT_OPTIONS, useValue: { restoreFocus: false } }
  ],
  bootstrap: [AppComponent]
})

export class AppModule {
  constructor(private translate: TranslateService, private personalizationService: PersonalizationService) {

    registerLocaleData(localeDE, 'de');
    localeEN[10][1] = 'yyyy/MM/dd';
    registerLocaleData(localeEN, 'en');

    this.translate.addLangs(['en', 'de']);
    this.translate.setDefaultLang('de');

    this.personalizationService.getValue('language').then((language) => {
      this.translate.use(language === 'en' ? 'en' : 'de');
    }).catch((error) => {
      this.translate.use('de');
    });
  }
}

